'use client'

import { forwardRef, useId } from 'react'
import SelectComponent from 'react-select'

import { useShareForwardedRef } from '@/utils/useShareForwardedRef'

import { ISelectHeaderProps } from './types'

const SelectHeader = forwardRef<HTMLSelectElement, ISelectHeaderProps>(
  ({ wFull = false, ...props }, ref) => {
    const innerRef = useShareForwardedRef<any>(ref)

    return (
      <div
        className={`relative flex flex-col justify-center ${props.className} ${
          wFull ? 'w-full' : ''
        }`}
      >
        {props.label ? (
          <label
            htmlFor={props.name}
            className="absolute -translate-y-[30px] prose-body-small text-grayscale-400 w-full"
          >
            {props.label}
          </label>
        ) : null}
        <SelectComponent
          placeholder={props.placeholder}
          name={props.name}
          id={useId()}
          instanceId={useId()}
          noOptionsMessage={() => 'Nenhuma opção encontrada'}
          classNames={{
            control: (state) =>
              `border-grayscale-200 bg-white flex flex-row justify-center prose-body
              ${
                state.hasValue || state.isFocused
                  ? 'text-black'
                  : 'text-grayscale-200'
              }
              ${state.isFocused ? 'border-2 border-tertiary-700' : 'border'}
              ${state.menuIsOpen ? ' rounded-t-lg' : 'rounded-lg'}`,
            dropdownIndicator: (state) =>
              `${state.selectProps.menuIsOpen ? 'transform rotate-180' : ''}
              ${state.isFocused ? 'text-tertiary-700' : 'text-grayscale-200'}
            `,
            menuList: () =>
              `overflow-y-auto overflow-x-hidden scrollbar-thin scrollbar-thumb-tertiary-700 scrollbar-track-grayscale-100 scrollbar-thumb-rounded scrollbar-track-rounded`,
            option: () =>
              'text-black hover:bg-tertiary-700 hover:bg-opacity-10 active:bg-tertiary-700 active:bg-opacity-10 prose-body py-3.5 px-4',
            menu: () =>
              'h-auto bg-white border-x border-b border-grayscale-200 rounded-b-lg',
          }}
          styles={{
            clearIndicator: () => ({
              display: 'none',
            }),
            control: (_base, props) => ({
              minWidth: '200px',
              minHeight: '40px',
              maxHeight: '40px',
              padding: props.isFocused ? '7px 15px' : '8px 16px',
            }),
          }}
          unstyled
          {...props}
          ref={innerRef}
        />
        {props.errorMessage ? (
          <label htmlFor={props.name} className="text-black prose-caption">
            {props.errorMessage}
          </label>
        ) : null}
      </div>
    )
  },
)

export default SelectHeader
